<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  @keyframes pushup-rotate-1 {
    0%,
    12.5% {
      opacity: 1;
    }
    12.5%,
    25% {
      opacity: 0;
    }
    25%,
    37.5% {
      opacity: 1;
    }
    37.5%,
    50% {
      opacity: 0;
    }
    50%,
    62.5% {
      opacity: 1;
    }
    62.5%,
    75% {
      opacity: 0;
    }
    75%,
    87.5% {
      opacity: 1;
    }
    87.5%,
    100% {
      opacity: 0;
    }
  }
  #pushup-rotate-1 {
    animation-name: pushup-rotate-1;
  }
  @keyframes pushup-rotate-2 {
    0%,
    12.5% {
      opacity: 0;
    }
    12.5%,
    25% {
      opacity: 1;
    }
    25%,
    62.5% {
      opacity: 0;
    }
    62.5%,
    75% {
      opacity: 1;
    }
    75%,
    100% {
      opacity: 0;
    }
  }
  #pushup-rotate-2 {
    animation-name: pushup-rotate-2;
  }
  @keyframes pushup-rotate-3 {
    0%,
    37.5% {
      opacity: 0;
    }
    37.5%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #pushup-rotate-3 {
    animation-name: pushup-rotate-3;
  }
  @keyframes pushup-rotate-4 {
    0%,
    87.5% {
      opacity: 0;
    }
    87.5%,
    100% {
      opacity: 1;
    }
  }
  #pushup-rotate-4 {
    animation-name: pushup-rotate-4;
  }

  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

}
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 625.3 495.8" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="pushup-rotate-3">
      <path
        fill="var(--hair)"
        d="M578 237a3 3 0 0 0-4 3c-1 19-17 18-30 22 1-5 4-9 9-12 6-3 7-8 2-13s-8-11-9-19c0-2-1-6-4-5-6 2-14-2-20 4-1 1-3 4-7 3 0-3 3-3 4-5 7-6 19-8 30-17 3-2 6 1 9 2 9 6 14 15 20 23ZM80 494c-8-5-16-9-21-18-1-2-4-6-2-8 3-3 6-8 12-7 7 3 13 0 19-4 4-3 9-1 13-1 3 5 7 11 0 16v3c-3 8-10 13-15 19Z"
      />
      <path
        fill="var(--shirt)"
        d="M499 281c0 13-4 26-6 39-1 7 2 15-3 21-6-4-14-2-20-5-11-6-9 2-10 8-3 0-6-2-6-6-1-8-5-9-12-5-14 7-28 12-43 15-7 2-9 8-15 11-7 3-14 5-21-2 7-6 7-12 3-19-5-10-11-20-18-29-9-15-18-30-24-47 30-18 60-36 93-48l2-1 7-2c8-2 13-5 7-14-4-5-1-9 3-13 6-9 13-16 21-22 3-3 4 0 5 2a50 50 0 0 0 12 16c5 13 13 26 15 41 0 6 0 13-3 19-9 15-3 34 13 41Z"
      />
      <path
        fill="var(--pants)"
        d="M324 262c5 17 15 32 24 47 7 9 13 19 18 29 4 7 4 13-3 19-11 11-25 18-40 23-17 6-32 15-43 29-4 4-7 4-11 0l-6-7c2-4 10-3 7-9-7-10-12-21-21-30 0-5 4-4 7-6 9-6 15-14 19-26l-32 13c-6 3-10 2-12-4 7-6 2-12-1-18l-16-27c12-10 28-14 43-17 20-2 38-12 58-15l9-1Z"
      />
      <path
        fill="var(--flesh)"
        d="m214 295 16 27c3 6 8 12 1 18l-9-2c-12 0-25 2-37-1-5-1-10 2-15 3-16 5-31 7-47 4-15-2-29 0-43 3-4-3-8-2-12-2-10-1-13-5-8-14l2-5c22 2 43-5 64-11 12-3 25-4 37-6 17-3 35-5 51-14ZM457 162c-8 6-15 13-21 22-6-2-4-8-7-11v-4c-2-6-3-13-7-19-9-29-9-58-12-88-1-13-11-23-14-35l-2-5a16 16 0 0 1-1-4c9 0 5-10 9-13l7 19c2-8 0-14-3-19 1-2 0-4 3-5 2 0 4 1 4 3 0 6 1 10 5 15V3c2-4 4-4 6 0 2 5 2 10 2 15 0 1-1 4 1 4 2 1 3-1 5-2l5-7a3 3 0 0 1 5 0v5c-6 7-7 17-13 24-3 4-4 10-2 16l4 22c5 28 13 56 26 82ZM499 281c-16-7-22-26-13-41 3-6 3-13 3-19 3 2-1 8 4 9 4 0 8-2 9-7 5-3 9-8 14-9l3 1c-1 2-4 2-3 5 3 1 5-2 6-3 6-6 14-2 20-4 3-1 4 3 4 5 1 8 5 13 9 19s4 10-2 13c-5 3-8 7-9 12-1 7-8 11-19 9-7-1-13 0-20 1-4 1-5 5-6 9Z"
      />
      <path
        fill="var(--hair)"
        d="M68 345c-10-1-13-5-8-14l2-5h-1c-1-3-3-2-5-1-11 0-22 0-33-5-7-3-16-3-23 3v7c7 10 16 17 28 19a67 67 0 0 1 26 9c4 3 7 3 11-1s9-8 15-10c-4-3-8-2-12-2Z"
      />
      <path
        fill="var(--flesh)"
        d="M249 363c9 9 14 20 21 30 3 6-5 5-7 9-18 8-38 14-54 29-9 9-21 14-33 18-24 9-49 13-71 25l-4 1v-3c7-5 3-11 0-16 1-3 3-3 6-4 16-4 29-13 41-23s26-17 41-20a21 21 0 0 0 11-7c14-17 32-28 49-39ZM460 344c1-6-1-14 10-8 6 3 14 1 20 5-4 12-3 23-1 35 3 11 0 22-1 34a262 262 0 0 0-1 37c0 9 5 12 14 12s18 0 27 4c3 1 7 2 6 7s-6 3-9 2l-8-2h-4c-7 14-17 1-25 2s-13-4-14-14l-9-69c-2-13 1-26-3-39 0-2 0-4-2-6Z"
      />
    </g>
    <g id="pushup-rotate-4">
      <path
        fill="var(--flesh)"
        d="M556 238c-5-5-8-11-9-18-1-2-2-6-5-5-6 1-13-2-19 3-2 2-4 5-7 4 0-3 2-3 3-5l-2-1c-6 1-10 6-14 9-1 5-5 7-10 7-5-1-1-7-3-10 0 7 0 14-4 20-9 15-3 33 14 40 0-3 1-7 6-8 6-1 13-3 19-1 11 2 19-2 20-9 1-5 3-9 8-12 6-3 8-8 3-14Zm-49 23v1Z"
      />
      <path
        fill="var(--hair)"
        d="M83 315a9 9 0 0 0-7-2l-18 6a81 81 0 0 0-15 12 52 52 0 0 0 0 11 6 6 0 0 1 0 1 52 52 0 0 0 5 9 64 64 0 0 1 7 3h4l12-5a5 5 0 0 1 2-1l4-5h-3a5 5 0 0 0 0-5l-1-1a5 5 0 0 0 4-6l2-1 2-1a13 13 0 0 0 4-5 8 8 0 0 0-2-10Z"
      />
      <path
        fill="var(--pants)"
        d="M325 264c5 17 14 32 24 47l18 28c4 8 4 14-3 20-12 11-26 18-41 23-17 6-31 15-43 29-3 4-7 4-10 0l-6-8c1-3 10-2 6-8-6-10-12-21-20-30-1-5 4-5 6-6 9-6 6-10 15-18-11 5-17 0-27 5-6 3-10 2-13-4 7-6 3-12-1-18l-16-28c13-10 28-14 44-16 20-3 38-12 57-15 4-1 7-2 10-1Z"
      />
      <path
        fill="var(--flesh)"
        d="m230 324-16-28c-15 10-33 12-50 14l-38 7c-21 6-41 13-64 11l-1 5c-5 9-3 13 7 14 4 0 8-1 11 1h5c13-2 26-4 39-2 16 3 32 0 47-4 5-2 10-4 15-3 13 2 25 1 38 1 3 0 5 0 8 2 7-6 3-12-1-18ZM457 163c-7 7-15 14-21 22-5-1-3-7-6-10l-1-4c-1-7-3-13-6-19-9-29-9-59-12-88-2-13-11-23-14-35l-3-6a16 16 0 0 1 0-3c8 0 4-10 9-13l6 19c2-9 1-14-2-19 0-2 0-5 2-5 3-1 4 1 5 3 0 5 0 10 5 15V5c2-4 3-4 5 0 3 5 2 10 2 15 0 1 0 3 2 4s3-1 4-2l6-7a3 3 0 0 1 4 0c2 1 2 3 0 5-5 7-6 17-12 24-4 4-4 10-3 16l4 22c5 28 13 56 26 81Z"
      />
      <path
        fill="var(--flesh)"
        d="M250 365c8 9 14 20 20 30 4 6-5 5-6 8-19 9-39 15-54 30-10 9-22 14-34 18-23 8-48 13-71 25l-3 1v-3c-16 0-31-3-9-17 1-3 12-2 14-3 16-4 29-13 41-23s26-17 41-21a22 22 0 0 0 12-7c13-16 31-27 49-38ZM461 346c0-7-2-14 10-8 6 3 14 1 20 5-4 11-4 23-1 35 2 11-1 22-2 33a262 262 0 0 0-1 38c1 9 6 12 14 12 9 0 18 0 27 3 4 2 8 2 6 8-1 5-5 2-9 2l-8-2h-3c-7 14-17 1-26 2s-12-4-13-14l-10-69c-2-13 2-26-2-39l-2-6Z"
      />
      <path
        fill="var(--hair)"
        d="M559 202c-3-2-7-5-10-2-11 9-23 10-30 17l-3 3a28 28 0 0 0-15 17 5 5 0 0 1 1 3l1 12a29 29 0 0 0 1 7l2 2a4 4 0 0 1 3 3l13 1 18 2a22 22 0 0 0 15-6c10-2 19-5 20-20a3 3 0 0 1 3-2v-14c-5-8-10-18-19-23Z"
      />
      <path
        fill="var(--shirt)"
        d="M419 215ZM500 282h-1a5 5 0 0 0-1-2l-5-9a17 17 0 0 1-1-2c-2-10-2-19-5-28 3-6 3-12 3-18-3-15-10-28-15-41a49 49 0 0 1-12-16c-2-3-2-5-6-3-7 7-15 14-21 23-4 3-6 8-3 13 6 9 1 12-6 14l-8 2-1 1c-34 12-63 30-93 48 5 17 14 32 24 47l18 28c4 8 4 14-3 20 6 7 13 4 21 1 6-2 8-9 14-10 15-3 30-8 43-15 8-4 11-3 12 5 1 4 3 6 7 6 0-7-2-14 10-8 6 3 14 1 20 5 4-7 2-14 3-21 2-13 5-26 6-40Z"
      />
      <path
        fill="var(--hair)"
        d="M77 456c-3 2-5 6-7 9s-1 3-1 4c-1 5 0 9 1 14a7 7 0 0 1 0 1 5 5 0 0 1 1 1l1 3 4 5 5 3h5c6-6 12-12 16-19a7 7 0 0 0 0-1l-1-2a32 32 0 0 1-8-13 5 5 0 0 1 0-4c-1 0 7-2 4-4-8-5-16 1-20 3Z"
      />
    </g>
    <g id="pushup-rotate-1">
      <path
        fill="var(--flesh)"
        d="M513 477c-7-1-13-3-21-3a51 51 0 0 1-20-1c-6-3-9-7-9-14 2-11 1-21 1-31l-1-11c0-3-1-4-3-4l-9-2c-9-1-14-7-14-16-1-13 1-25 2-38l2-31a17 17 0 0 1 1-5c5-2 9-3 14-2l-2 17c0 5 0 5 5 5l-5 26-4 20c0 6 2 9 9 10 2 0 3-1 3-3v-19c0-11 3-22 1-34a72 72 0 0 1 9 1c4 1 8 3 12-2 0 0 3-1 4 1s2 2 3 2h6l-3 4c-1 5-4 11-2 17 1 4 0 8-1 12l-6 35-3 16-2 23c-1 2 0 2 2 2l7-2h4c1 1 0 3-1 3-2 4 0 4 2 3a98 98 0 0 1 28 3c1 1 3 1 2 4l3 2c2 1 4 1 2 4v2c0 2-1 3-3 3l-10-2c3 2 2 4 1 5Z"
      />
      <path
        fill="var(--hair)"
        d="M102 415c1 0 2 0 1 2-5 7-3 14-2 21 1 1 1 2 3 2l18 6c3 2 4 8 1 10-13 7-26 11-40 7-8-3-13-7-15-16l-12-24-7-15v-4c5-6 11-11 20-10a15 15 0 0 0 8-1h2a11 11 0 0 1-3 8c-4 5-3 11 2 14a32 32 0 0 0 10 3c5 1 6 1 10-2a11 11 0 0 1 4-1Z"
      />
      <path
        d="M459 341c-5 0-5 0-5-5l2-17c-5-1-9 0-14 2l-21 6c-10 4-21 7-31 12a8 8 0 0 1-7 1c-3-2-6 0-10 0a118 118 0 0 1-16 3c-2 0-3 0-3-3l-1-6c0-1 0-2-2-3a4 4 0 0 0 1-2 138 138 0 0 1-3-30 24 24 0 0 0-3-13c-5-8-6-16-4-25 4 0 7-1 11-3h7c4-3 8-4 13-3a4 4 0 0 0 3 0l39-14a133 133 0 0 1 67-1c6 2 12 4 18 9l5 2c3 0 4 1 4 4l1 2-2 17c-1 5-3 9-3 14 0 6 1 12-1 17-4 6-3 13-4 19l-3 19h-6c-1 0-2 0-3-2s-4-1-4-1c-4 5-8 3-12 2a72 72 0 0 0-9 0Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--pants)"
        d="M342 261c-2 9-1 17 4 25a24 24 0 0 1 3 13 138 138 0 0 0 3 30 4 4 0 0 1-1 2c-2 1-4 3-5 6a24 24 0 0 1-11 8c-14 6-29 12-44 16a186 186 0 0 0-43 16c-3 2-5 0-7-2l-7-11c1-2 2-2 3-2s2-2 1-3c-4-4-6-11-9-16-3-6-7-12-9-19l1-3c15-7 27-18 41-26 11-7 23-13 34-22a60 60 0 0 1 15-10c9-4 19-6 29-3a13 13 0 0 1 2 1Z"
      />
      <path
        fill="var(--flesh)"
        d="M220 324c2 7 6 13 9 19 3 5 5 12 9 16 1 1 0 2-1 3s-2 0-3 2c-3 0-5 2-7 3a95 95 0 0 1-15 4l-21 4c-8 0-15 5-22 8a146 146 0 0 1-28 11c-5 2-11 2-16 5-3 1-6 1-8 4-6 2-9 6-14 10l-1 2a11 11 0 0 0-4 1c-4 3-5 3-10 2a32 32 0 0 1-10-3c-5-3-6-9-2-14a11 11 0 0 0 3-8c7-1 14-5 21-9 2-2 6-3 8-6a6 6 0 0 0 2 0l14-8c5-3 8-6 10-12a20 20 0 0 0 12-5 41 41 0 0 1 15-7 25 25 0 0 0 7-4c9-6 17-12 27-15 8-2 17-2 25-3ZM504 305c2-5 1-11 1-17 0-5 2-9 3-14l2-17c3 2 6 4 9 2 4-2 9-2 13-5 3-2 7-1 9 2s1 6-2 9a15 15 0 0 1-5 3c-4 1-4 3-1 6a13 13 0 0 0 11 4c5-1 10 1 13 5 1 2 3 3 5 1s3-2 5-1 3 4 2 6a21 21 0 0 1-2 9c-4 0-7 3-10 4l-7 2c-5 0-8 3-11 6-4 4-5 4-9 1h-3c-4 2-8 2-11-1a3 3 0 0 0-3 0c-5 1-7 0-9-5Z"
      />
      <path
        fill="var(--hair)"
        d="M567 298a21 21 0 0 0 2-9c1-2 0-4-2-6s-4 0-5 1-4 1-5-1c-3-4-8-6-13-5a13 13 0 0 1-11-4c-3-3-2-5 1-6a15 15 0 0 0 5-3c3-3 3-6 2-9s-6-4-9-2c-4 3-9 3-13 5-3 2-6 0-9-2l-1-3c-1-1 0-3 2-3a31 31 0 0 0 9-4c10-5 20-8 30-11 9-2 20 4 23 12l6 14a16 16 0 0 1 1 7 79 79 0 0 0 1 10l2 16c1 4-1 5-6 6l-10-3ZM134 358c-2 5-6 9-10 12l-14 8a6 6 0 0 1-2 0l-1-5c-2-8-2-8 5-11a30 30 0 0 1 11-3c3 0 6-1 8-3s3-1 3 2ZM117 403c2-3 5-3 8-4 5-3 11-3 16-5a3 3 0 0 1 0 1c-1 7-1 7 6 11 2 1 5 2 6 4 2 3 1 6-2 8-7 3-15 4-23 3a10 10 0 0 1-7-7l-4-11Z"
      />
    </g>
    <g id="pushup-rotate-2">
      <path
        fill="var(--hair)"
        d="M625 422c-4 6-3 14-5 20-2 4 0 8-4 10s-8-2-11-5l4-8c1-4 2-8-5-6a3 3 0 0 1-4-2c-1-4-4-3-7-2a13 13 0 0 1-11 0 5 5 0 0 1-3-6c1-3 3-1 5-2h5c2 0 5-1 6-3 1-3 0-6-2-8-3-3-6-4-9-4-9 0-14-5-17-13 9-7 20-8 31-9 5-1 10-2 15 0a22 22 0 0 1 12 12ZM91 422l-7 18c-1 3-1 5 2 6a31 31 0 0 1 7 4c5 3 5 8 0 11-8 5-27 3-33-4-4-5-5-12-5-18 0-11 0-22-4-33l-3-4v-10c13-3 25-3 38-2a2 2 0 0 1 2 1c-8-1-12 3-14 10a20 20 0 0 1-2 3c-4 6-3 9 4 17 4 4 7 7 12 1h3Z"
      />
      <path
        d="M390 432c-7 3-12 9-20 10-18 1-36 3-54 2-12-1-23 1-35 3-9 1-10 0-13-8l-2-8c0-15-1-29-3-44 3-4 7-3 11-4 3 0 6-1 6-4 1-3 3-3 5-3l22-4a216 216 0 0 0 50-14 50 50 0 0 1 29-3c6 1 11 2 15 6-4 8-6 17-3 25a22 22 0 0 1 0 12 273 273 0 0 0-8 34Z"
        fill="var(--pants)"
      />
      <path
        fill="var(--flesh)"
        d="M263 387c2 15 3 29 3 44-17-4-33 0-50-3a40 40 0 0 1-7-1c-17-6-35-4-52-7-10-2-20-1-30-1-10-3-20-1-30 1l-6 2-3 1c-5 5-8 2-12-2-7-8-8-11-4-17a20 20 0 0 0 2-3c2-7 6-11 14-10h8a269 269 0 0 0 37-3c13 0 25-2 38-3 19-3 38-4 57 1 11 3 23 4 35 1Z"
      />
      <path
        fill="var(--shirt)"
        d="M390 432a273 273 0 0 1 8-34 22 22 0 0 0 0-12c-3-8-1-17 3-25 4 3 10 2 14 7a3 3 0 0 0 2 0c9-2 17 4 26 1 8 1 16-5 24-2l-4 3-5 15c-2 15 3 29 6 43l4 20a218 218 0 0 0-34 3c-13 2-24-4-36-4l-4-1c-4 0-5-2-4-6 0-3 2-5 0-8Z"
      />
      <path
        fill="var(--flesh)"
        d="m468 448-4-20c-3-14-8-28-6-43l5-15 4-3c-8-3-16 3-24 2l1-6c2-3 4-7 8-7 13 0 25 1 36 7-1 1-3 2 1 3 10 2 20 2 28 9 5 4 6 8 4 14l-4 10c-1 3 0 8-4 9-3 1-4 3-6 5-4 6-8 7-14 4-3-2-5-1-5 2l-2 12c-1 5-2 12 1 17 0 5 2 6 7 7a180 180 0 0 1 44 8c1 0 4 1 3 3 0 2-2 3-4 4-19 4-38 0-57 1-4 0-6-3-7-7a70 70 0 0 0-5-16Z"
      />
      <path
        fill="var(--shirt)"
        d="M487 449c-3-6-2-13-1-18l2-12c0-3 2-4 5-2 6 3 10 2 14-4 2-2 3-4 6-5 4-1 3-6 4-9l4-10c2-6 1-10-4-14-8-7-18-7-28-9-4-1-2-2-1-3 12 1 23 1 34 5a82 82 0 0 1 34 23 117 117 0 0 1-8 35 106 106 0 0 1-20 20c-7 5-16 5-25 4l-16-1Z"
      />
      <path
        fill="var(--flesh)"
        d="M548 426a117 117 0 0 0 8-35c3 3 7 2 11 3 3 7 8 12 17 12 3 1 6 1 9 4 2 2 3 5 2 8-1 2-4 3-6 3h-5c-2 0-4-1-5 2a5 5 0 0 0 3 6 13 13 0 0 0 11 0c3-1 6-2 7 2a3 3 0 0 0 4 2c7-2 6 2 5 6l-4 8c-10 3-21-1-30 7h-3c-4-4-10-2-14-6l-2-1c-10-1-7-8-6-14 1-2 2-6-2-7Z"
      />
      <path
        fill="var(--hair)"
        d="M133 388a269 269 0 0 1-37 3c0-6 1-8 8-8 10 0 20 1 29 5ZM97 420c10-2 20-4 30-1l-4 5c-6 9-6 10 3 15 2 2 4 3 3 6 0 2-2 3-4 4-9 3-18 2-26-2-4-1-5-4-4-8l2-19Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>